"use strict";

import "./POICrossingNotificationConfigForm.css";

import React from "react";
import ReactDOM from "react-dom";

import Form from "vwa/components/Form";
import MultiSelector from "vwa/components/MultiSelector";
import Checkbox from "vwa/components/Checkbox";
import lang from "vwa/lang";

import getModificationsByRef from "vfu/getModificationsByRef";

import {getUserId} from "./../../../utils/user";
import {getEventDescriptorFromNotificationConfig} from "./../../../utils/notification";

export default class POICrossingNotificationConfigForm extends React.Component {
	
	constructor(props){
		super(props);
		this.initState();
	}
	
	initState(){
		this.state = this.getDefaultState();
	}
	
	componentDidUpdate(_, prevState){
		if(!!getModificationsByRef(prevState, this.state)){
			this.props.onChange(this.getEventDescriptor(), this.getNotificationConfig());
		}
	}
	
	clear(){
		this.setState(this.getDefaultState());
		this.refs.poiSelector.clear();
		this.refs.vehicleSelector.clear();
	}
	
	getDefaultPOIsFromAssignmentDescriptor(assignmentDescriptor){
		if(assignmentDescriptor.user){
			return null;
		}
		else{
			return assignmentDescriptor.pois;
		}
	}
	
	getDefaultVehiclesFromAssignmentDescriptor(assignmentDescriptor){
		if(assignmentDescriptor.user){
			return null;
		}
		else{
			return assignmentDescriptor.carriers;
		}
	}
	
	getDefaultState(){
		const eventDescriptor = getEventDescriptorFromNotificationConfig(this.props.notificationConfig);
		
		return {
			pois: 		this.props.notificationConfig ? this.getDefaultPOIsFromAssignmentDescriptor(eventDescriptor.pois) : null,
			vehicles: 	this.props.notificationConfig ? this.getDefaultVehiclesFromAssignmentDescriptor(eventDescriptor.carriers) : null,
			arriving: 	this.props.notificationConfig ? eventDescriptor.arriving : true,
			departing: 	this.props.notificationConfig ? eventDescriptor.departing : true,
			web: 		this.props.notificationConfig ? this.props.notificationConfig.web : true,
			email: 		this.props.notificationConfig ? this.props.notificationConfig.email : false,
			sms: 		this.props.notificationConfig ? this.props.notificationConfig.sms : false
		};
	}
	
	getPOIOptions(){
		if(this.props.pois){
			return this.props.pois.map(poi => ({
				value: poi._id,
				label: poi.name
			}));
		}
		else{
			return [];
		}
	}
	
	getVehicleOptions(){
		if(this.props.vehicles){
			return this.props.vehicles.map(vehicle => ({
				value: vehicle._id,
				label: vehicle.name
			}));
		}
		else{
			return [];
		}
	}
	
	getVehiclesAssignmentDescriptor(){
		return({
			user: this.state.vehicles ? null : getUserId(),
			type: "CarrierAssignmentDescriptor",
			carriers: this.state.vehicles ? this.state.vehicles : null
		});
	}
	
	getPOIsAssignmentDescriptor(){
		return({
			user: this.state.pois ? null : getUserId(),
			type: "POIAssignmentDescriptor",
			pois: this.state.pois ? this.state.pois : null
		});
	}
	
	getEventDescriptor(){
		let eventDescriptor = {
			carriers: 	this.getVehiclesAssignmentDescriptor(),
			pois:		this.getPOIsAssignmentDescriptor(),
			arriving: 	this.state.arriving,
			departing: 	this.state.departing,
			type: 		"POICrossingDescriptor"
		};
		
		if(this.props.notificationConfig){
			eventDescriptor = Object.assign(eventDescriptor, {_id: this.props.notificationConfig.descriptor});
		}
		
		return eventDescriptor;
	}
	
	getNotificationConfig(){
		return {
			web: 	this.state.web,
			email: 	this.state.email,
			sms: 	this.state.sms
		};
	}
	
	render(){
		return(
			<Form className="POICrossingNotificationConfigForm">
				<MultiSelector
					title={lang.POIS}
					ref="poiSelector"
					options={this.getPOIOptions()}
					onChange={(pois, all) => this.setState({pois: all ? null : pois})}
					defaultValue={this.state.pois}
				/>
				<MultiSelector
					title={lang.VEHICLES}
					ref="vehicleSelector"
					options={this.getVehicleOptions()}
					onChange={(vehicles, all) => this.setState({vehicles: all ? null : vehicles})}
					defaultValue={this.state.vehicles}
				/>
				<div className="CheckboxContainer">
					<label className="Title">{lang.SEND_NOTIFICATIONS_AT}</label>
					<Checkbox
						checked={this.state.arriving}
						onChange={value => this.setState({arriving: value})}
					/>
					<label>{lang.ARRIVING}</label>
					<Checkbox
						checked={this.state.departing}
						onChange={value => this.setState({departing: value})}
					/>
					<label>{lang.DEPARTING}</label>
				</div>
				<div>
					<label className="Title">{lang.SEND_NOTIFICATIONS_VIA}</label>
					<div className="CheckboxContainer">
						<Checkbox
							checked={this.state.web}
							onChange={value => this.setState({web: value})}
						/>
						<label>{lang.WEB}</label>
						<Checkbox
							checked={this.state.email}
							onChange={value => this.setState({email: value})}
						/>
						<label>{lang.EMAIL}</label>
						<Checkbox
							checked={this.state.sms}
							onChange={value => this.setState({sms: value})}
						/>
						<label>{lang.TEXT_MESSAGE}</label>
					</div>
				</div>
			</Form>
		);
	}
	
}

POICrossingNotificationConfigForm.propTypes = {
	pois: 				React.PropTypes.array,
	vehicles:			React.PropTypes.array,
	onChange: 			React.PropTypes.func,
	notificationConfig: React.PropTypes.object
};

POICrossingNotificationConfigForm.defaultProps = {
	pois: 				[],
	vehicles: 			[],
	onChange: 			(getEventDescriptor, NotificationConfig) => {},
	notificationConfig: null
};


// WEBPACK FOOTER //
// ./src/view/POICrossingNotifications/POICrossingNotificationConfigForm/POICrossingNotificationConfigForm.jsx